<content>
    <section>
        <h2>{{'mantenimientoVersionesEtiquetado.modal.datosActualizacion' | translate}}</h2>
        <form [formGroup]="newEditForm" [ngClass]="{ 'show-error': showError }">
            <div class="entry-single">
                <label>{{'mantenimientoVersionesEtiquetado.modal.version' | translate}} *</label>
                <input type="text" formControlName="version" />
            </div>
            <div class="entry-single">
                <label>{{'mantenimientoVersionesEtiquetado.modal.observaciones' | translate}}</label>
                <textarea formControlName="observaciones"></textarea>
            </div>
            <div class="entry-single alignment-start">
                <input type="checkbox" id="actualizacionAutomaticaTodasLicencias" formControlName="actualizacionAutomaticaTodasLicencias">
                <label for="actualizacionAutomaticaTodasLicencias" style="white-space: nowrap;">{{'mantenimientoVersionesEtiquetado.modal.licencias' | translate}}</label>
              </div>
        </form>
    </section>
    <app-asociar-actualizaciones-sw *ngIf="!newEditForm.get('actualizacionAutomaticaTodasLicencias').value" (emitActualizaciones)="lsActualizacionAutomatica = $event"></app-asociar-actualizaciones-sw>
</content>
<footer class="button-bar-right">
    <button class="secondary" (click)="close()">
        {{ "global.cancelar" | translate }}
    </button>
    <button (click)="save()">
        {{
        versionSwId
        ? ("global.actualizar" | translate)
        : ("global.insertar" | translate)
        }}
    </button>
</footer>
<app-toast *ngIf="(showError || showApiError) && mensajes" [messages]="mensajes" (closed)="showError=$event;showApiError=$event"></app-toast>